module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-right-top-metals-remnants.29f8d06e.png";